// Copyright (C) Digital Jetty Konrad Gadzinowski - All Rights Reserved

export class SoundAlarm {

  private static readonly STORAGE_KEY = "orders-sound-alarm"
  private static readonly CSS_ICON_ON = "bi-bell-fill"
  private static readonly CSS_ICON_OFF = "bi-bell-slash"

  // On by default: only an explicit opt-out disables it.
  public static isEnabled = (): boolean => localStorage.getItem(SoundAlarm.STORAGE_KEY) !== "false"

  public static setEnabled = (enabled: boolean): void => {
    localStorage.setItem(SoundAlarm.STORAGE_KEY, enabled ? "true" : "false")
  }

  public static syncButton = (button: HTMLElement): void => {
    const enabled = SoundAlarm.isEnabled()
    const icon = button.querySelector("i")
    icon?.classList.toggle(SoundAlarm.CSS_ICON_ON, enabled)
    icon?.classList.toggle(SoundAlarm.CSS_ICON_OFF, !enabled)
    button.setAttribute("aria-pressed", enabled ? "true" : "false")
  }
}
